import { BaseEntityDto } from './base-entity.dto';
import { AdminNotePriority } from '../../enums';

export interface AdminNoteDto extends BaseEntityDto {
  entityId: string; // Guid
  entityType: string;
  category: string;
  content: string;
  isInternal: boolean;
  priority: AdminNotePriority;
  createdByUserId: string; // Guid
  createdByUserName: string;
}
